<template>
  <div class="cart">
    <div class="table-box">
      <div>
        <!-- <div class="top">
          <div class="title">全部商品 {{ buytotal }}</div>
          <div class="daoru">批量导入</div>
        </div> -->
        <div>  
          <el-tabs v-model="activeName" @tab-click="handleClick">
           <el-tab-pane :label="$t('menu.erlunpej')" name="1"></el-tab-pane>
            <el-tab-pane :label="$t('menu.erlunzhengc')"  name="2"></el-tab-pane>
              <el-tab-pane :label="$t('menu.silunpej')" name="3"></el-tab-pane>
            <el-tab-pane :label="$t('menu.silunzhengc')"  name="4"></el-tab-pane>
                <el-tab-pane :label="$t('menu.zhoubianq')"  name="9000"></el-tab-pane>
          </el-tabs>
        </div>
        <el-table  empty-text=" " :data="cartList" ref="multipleTable" border height="600"
          style="width: 100%;height: 80vh;overflow: auto;" @selection-change="handleSelectionChange"
          @row-click="clickRow">
          <el-table-column type="selection" width="45"> </el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.Code')" width="160" align="center">
            <template slot-scope="scope">
              <div @click="xzclick(scope.row)">{{ scope.row.partNumber }}</div>
              <!-- <div>{{ scope.row.partCategory.mcSeriesModelId }}</div> -->
            </template> </el-table-column>
          <el-table-column prop="partName" :label="$t('menu.Product')" width="260" align="center">
            <template slot-scope="scope">
              <div @click="xzclick(scope.row)">{{ inle == 'zh' ? scope.row.part.partName : scope.row.part.partNameEn }}
              </div>
              <!-- <div>{{ scope.row.partCategory.mcSeriesModelId }}</div> -->
            </template>
          </el-table-column>
          <el-table-column prop="cx" :label="$t('menu.VehicleModel')" align="center">
            <template slot-scope="scope">
              <div @click="xzclick(scope.row)">{{ formatChe(scope.row.partCategory.mcSeriesModelId) }}</div>

            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" align="center">
            <template slot-scope="scope">

              <div v-if="bz == 'CNY'" @click="xzclick(scope.row)">{{ fhstuse(moneyType) }} {{ scope.row.unitPrice }}
              </div>
              <div v-if="bz == 'USD'&&tup!=='2'" @click="xzclick(scope.row)">{{ fhstuse(moneyType) }} {{
                scope.row.part.purchasePriceUsd }}
              </div>
              <div v-if="bz == 'EUR'&&tup!=='2'" @click="xzclick(scope.row)">{{ fhstuse(moneyType) }} {{
                scope.row.part.purchasePriceEur }}
              </div>
<div v-if="bz == 'USD'&&tup=='2'" @click="xzclick(scope.row)">{{ fhstuse(moneyType) }} {{
                scope.row.unitPrice }}
              </div>
              <div v-if="bz == 'EUR'&&tup=='2'" @click="xzclick(scope.row)">{{ fhstuse(moneyType) }} {{
                scope.row.unitPrice }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="part.minPurchaseQuantity" :label="$t('menu.MOQ')" align="center"> </el-table-column> -->


          <!-- <el-table-column prop="num" label="数量" width="200" align="center">
            <template slot-scope="scope">
              <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                <el-input-number style="transform: scale(0.7);" v-model="scope.row.quantity"
                  :min="scope.row.part.minPurchaseQuantity" @change="changeNum($event, scope.row.id)"></el-input-number>

              </div>

            </template>
          </el-table-column> -->


          <el-table-column prop="num" :label="$t('menu.Quantity')" width="150" align="center">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center;" @click="xzclick(scope.row)">
                <i class="el-icon-minus" @click.stop="changeNum('del', scope.row.quantity, scope.row.id)"></i>
                <div class="input-number">{{ scope.row.quantity }}</div>
                <i class="el-icon-plus" @click.stop="changeNum('add', scope.row.quantity, scope.row.id)"></i>


              </div>

            </template>
          </el-table-column>




          <el-table-column prop="amount" :label="$t('menu.Amount')" align="center">
            <template slot-scope="scope">
              <div>{{ fhstuse(moneyType) }} {{ formatPrice(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" align="center" width="55">
            <template slot="header" slot-scope="scope">
              <div>{{ $t('menu.Operation') }}</div>
            </template>
            <template slot-scope="scope">
              <!-- <div class="del" @click="del(scope.row.id)">{{ $t('menu.Delete') }}</div> -->
              <i class="el-icon-delete" style="font-size: 25px;cursor: pointer;" @click="del(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>


      
      <div class="daoru"  style="width: 100%; display: flex;cursor: pointer;justify-content: space-between;
    align-items: center;">
        <div @click="openDaoRuDialog()">{{ $t('menu.Uploadorder') }}</div>
        <div @click="plss()">{{ $t('menu.plshanc') }}</div>
      </div>

      <!-- ************************ -->

      <!-- <div style="margin-top: 40px;" v-if="cartLista.length > 0">
        <div class="top">
          <div class="wuxiao">{{ $t('menu.InvalidProduct') }} 1</div>
          <div class="qingkong" @click="qxdel">{{ $t('menu.ClearInvalidProducts') }}</div>
        </div>
        <el-table :data="cartLista" border height="400" style="width: 100%">

          <el-table-column prop="partNumber" :label="$t('menu.Code')" width="180" align="center"> </el-table-column>
          <el-table-column prop="partName" :label="$t('menu.Product')" align="center">
            <template slot-scope="scope">
              <div>{{ inle == 'zh' ? scope.row.part.partName : scope.row.part.partNameEn }}</div>
             
            </template>
          </el-table-column>
       
          <el-table-column prop="address" width="180" align="center">
            <template slot="header" slot-scope="scope">
              <div>{{ $t('menu.Operation') }}</div>
            </template>
            <template slot-scope="scope">
              <i class="el-icon-delete" style="font-size: 25px;cursor: pointer;" @click="del(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
    </div>
    <div class="info-box">
      <div class="top1">
        <div style="font-weight: 600;">{{ $t('menu.SubTotal') }} ( {{ buytotal }} {{ $t('menu.item') }}）</div>
        <div class="pri">{{ priceTotal }} <p>{{ moneyType }}</p>
        </div>
      </div>

        <div  class="pay-type">

          <div style="border-bottom: 1px solid #eee;">
               <div style="display: flex;align-items: center; justify-content: space-between;" class="blance" >
          
              <el-checkbox v-model="radiodk" >{{ accTypeIdtt(accTypeId) }}</el-checkbox>
           <div >{{ ccbaopl(priceTotal/100*zkbi) }}{{ moneyType }}</div>
          </div>
          <div style="margin: 10px 0;">{{ $t('menu.yefy') }}：{{ accountBalance }} {{ moneyType }}，{{ $t('menu.dczdddk') }}{{ zkbi }}%</div>
          </div>
          <div style="margin: 10px 0;">
            {{ $t('menu.zpnmji') }}：
               <span v-if="radiodk==true">
            
           <span v-if="priceTotal/100*zkbi>accountBalance">
              {{ ccbaopl(priceTotal-accountBalance) }}<span style="margin-left: 5px;">{{ moneyType }}</span>
           </span>
           <span v-else>
              {{ ccbaopl(priceTotal-priceTotal/100*zkbi) }}<span style="margin-left: 5px;">{{ moneyType }}</span>
            </span>
            </span>
            <span v-else>
              {{ ccbaopl(priceTotal) }}<span style="margin-left: 5px;">{{ moneyType }}</span>
            </span>
          </div>
        </div>

      <div class="item">
        <div class="title">{{ $t('menu.PaymentMethod') }}</div>
      </div>
      <div class="pay-type">
        <el-radio v-model="radioa" label="cash">{{ $t('menu.TransferAccounts') }}</el-radio>
        <div style="display: flex;align-items: center;
               justify-content: space-between;" class="blance">
  <!-- <el-radio v-if="tup=='2'" v-model="radioa" label="account">{{ $t('menu.lingshouzhanghzf') }}</el-radio>
          <div v-if="tup=='2'">{{ accountBalance }} {{ moneyType }}</div> -->
            <!-- 德国不显示  endamoto.com-->
          <!-- <el-radio v-if="tup=='1'" v-model="radioa" label="account">{{ $t('menu.Accountdeduction') }}</el-radio>
          <div v-if="tup=='1'">{{ accountBalance }} {{ moneyType }}</div> -->

        <!-- 德国不显示到这里截至 -->

        </div>

      </div>


      <div class="item" v-if="radioa == 'account' && priceTotal > accountBalance && inle == 'zh'"
        style="color: red; font-size: 14px;">
        余额不足
      </div>
      <div class="item" v-if="radioa == 'account' && priceTotal > accountBalance && inle !== 'zh'"
        style="color: red; font-size: 14px;">
        Amount is insufficient
      </div>

       <!-- 德国不显示 endamoto.com -->
      <div v-if="tup=='1'" class="item">
        <div class="title" style="position: relative;">
          <p style="position: absolute;left: -5px;color: red;">*</p>{{ $t('menu.Country') }}
        </div>
      </div>
      <div v-if="tup=='1'" class="hy-type">
        <el-select style="width: 100%;" v-model="ckg" :placeholder="$t('menu.Country')">
          <el-option v-for="item in gb" :key="item.dictValue" :label="bbca(item.dictLabel)" :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
      <div v-if="tup=='1'" class="item">
        <div class="title" style="position: relative;">
          <p style="position: absolute;left: -5px;color: red;">*</p>{{ $t('menu.FreightMode') }}
        </div>

      </div>
      <div v-if="tup=='1'" class="hy-type">
        <el-select style="width: 100%;" v-model="hyVal" :placeholder="$t('menu.Shippingtype')">
          <el-option v-if="inle == 'zh'" v-for="item in hyList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
          <el-option v-if="inle !== 'zh'" v-for="item in hyList" :key="item.dictValue" :label="item.dictLabelEn"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
      <!-- 德国不显示这里截至 -->








      <!-- <div class="item">
        <div class="title">价格条款</div>
        <div class="hy-type">
          <el-select v-model="jgVal" placeholder="请选择价格条款">
            <el-option v-for="item in prList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
      </div> -->


      <!-- <div class="item">
        <div class="title">收货地址</div>
        <div class="address">
          <div class="gh" @click="openPop">更换</div>
          <div class="name">{{raddata.invoiceName}}</div>
          <div class="mobile">{{raddata.invoiceMobile}}</div>
          <div class="addr">{{raddata.invoiceAddress}}</div>
        </div>
      </div> -->

      <div class="item">
        <div class="title">{{ $t('menu.ExpectedShippingdate') }}</div>

      </div>
      <div class="pay-type">
        <el-date-picker style="width: 100%;" v-model="shippingDate" type="date" :placeholder="$t('menu.Expected')"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>

      <div class="item">
        <div class="title">{{ $t('menu.CustomerOrderNo') }}</div>

      </div>
      <div class="pay-type">
        <el-input :placeholder="$t('menu.Enter')" style="width: 100%;" v-model="planNum"></el-input>
      </div>
      <div class="item">
        <div class="title">{{ $t('menu.Remarks') }}</div>

      </div>
      <div class="pay-type">
        <el-input type="textarea" :placeholder="$t('menu.Enter')" :rows="3"
          style="width: 100%;font-family: 'element-icons'" v-model="remark"></el-input>
      </div>
      <el-button type="primary" :disabled="checkDisabled()"
        :class="Number(priceTotal) > Number(accountBalance) && radioa == 'account' ? 'hui' : '' || btnType == true ? 'hui' : ''"
        class="submit-btn" @click="updata()">{{ $t('menu.Submit') }}</el-button>

    </div>



    <el-dialog title="收货地址" :visible.sync="addressPop">
      <el-table  empty-text=" " :data="addressData" border>
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.id" @click="clickChange(scope.row.id)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="dealerNameAbb" :label="$t('menu.Country')" width="150" align="center"></el-table-column>
        <el-table-column prop="invoiceName" :label="$t('menu.Addressee')" width="200" align="center"></el-table-column>
        <el-table-column prop="invoiceMobile" :label="$t('menu.contactNumber')" align="center"></el-table-column>
        <el-table-column prop="invoiceAddress" :label="$t('menu.DeliveryAddress')" align="center"></el-table-column>
      </el-table>

      <el-button @click="confirmAddress">{{ $t('menu.Confirm') }}</el-button>

    </el-dialog>


    <el-dialog :title="$t('menu.CheckoutSuccess')" :visible.sync="successType" width="20%">
      <div style="display: flex; justify-content: center;">
        {{ $t('menu.Amount') }}：{{ buySum }}.{{ moneyType }}
      </div>
      <div style="margin-top: 30px;display: flex; justify-content: space-evenly;">
        <el-button @click="successType = false">{{ $t('menu.Continueordering') }}</el-button>
        <el-button type="primary" @click="ckbd()">{{ $t('menu.Orderdetails') }}</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="$t('menu.Import')" :visible.sync="daoruFlag" width="30%">
      <div class="daoru-big">
        <div class="daoru-box">
          <div>{{ $t('menu.PartsImportTemplate') }}</div>
          <div class="daoru-download" @click="downMoBan">{{ $t('menu.Download') }}</div>
        </div>
        <el-upload class="mgauto" action="" :http-request="httpRequest" :show-file-list="false" :file-list="fileList">
          <div class="daoru-btn" size="small" type="primary">{{ $t('menu.SelectFile') }}</div>
        </el-upload>

        <!-- <div class="daoru-btn">{{ $t('menu.Import') }}</div> -->
      </div>

      <!-- <div>检测到：78个配件</div> -->

      <div style="display: flex; justify-content: space-evenly;">
        <!-- <div class="daoru-confirm">确定</div> -->
        <!-- <div class="daoru-confirm cconfirm">确定注册</div> -->
        <!-- <div class="daoru-confirm cconfirm">确定</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  cartDel,
  cartList,
  cartQuantity,
  cartorder,
  getInfo,
  myAcc,
  querytype,
  gbquerytype,
  listAccType,
  listMcSeriesModels,
  cartordera,
  importFile
} from '../../api/api';
import axios from "axios"
export default {
  data () {
    return {
      downUrl: '',
      fileList: [],
      successType: false,
      btnType: false,
      activeName:'1',
      addressPop: false,
      accTypeId: null,
      date: '',
       radiodk:'0',
      jihuaL: '',
      cbaac:'',
      accountBalance: 0,
      remark: '',
      cartList: [],
      tableData: [],
      raddata: {},
      radioa: 'cash',
      xlist: [],
      radio: {},
      jgVal: '',
      jihua: '',
      ckg: '',
      hyVal: '',
      shippingDate: '',
      zkbi:0,
      list: [
        {
          id: 0,
          bm: '23U00.4182',
          cp: 'HORN',
          cx: 'LFC700',
          dj: '43.1',
          qd: '3',
          num: 1,
          xj: '',
        }
      ],
      hyList: [
        {
          label: '空运',
          value: '0'
        },
        {
          label: '散运',
          value: '1'
        },
        {
          label: '货柜',
          value: '2'
        }
      ],
      prList: [
        {
          label: 'FOB',
          value: '0'
        },
        {
          label: 'N/O',
          value: '1'
        }
      ],
      addressData: [],
      selectList: [],
      value1: '',
      uesrid: '',
      gb: [],
      planNum: '',
      accountList: [],
      acclist:[],
      moneyType: '',
      buySum: '',
      cheList: [],
      cartLista: [],
      bz: 'CNY',
      inle: 'zh',
      aeera: [],
      daoruFlag: false,
      carttype:'1',
      tup:'1'
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.tup = sessionStorage.getItem('platform')
    this.inle = a
    this.getInfoa()
    this.getCartList()
    this.jg()
    this.myacc()
    this.accc()
    this.getListAccType()
    this.getlistMcSeriesModels()

    this.aeer()
    this.downloadUrl()
    this.gbquerytype()
    this.moneyType = this.bz

  },
  computed: {
    buytotal () {
      let num = 0
      this.selectList.forEach(i => {
        num += i.quantity
      })
      return num
    },
    priceTotal () {
      let num = 0
      if(this.tup=='2'){
        if (this.bz == 'CNY') {
        this.selectList.forEach(i => {
          num += i.quantity * i.unitPrice
        })
      } else if (this.bz == 'USD') {
        this.selectList.forEach(i => {
          num += i.quantity * i.unitPrice
        })
      }
      else {

        this.selectList.forEach(i => {
          num += i.quantity * i.unitPrice
        })

      }
      }else{
        if (this.bz == 'CNY') {
        this.selectList.forEach(i => {
          num += i.quantity * i.part.purchasePriceCny
        })
      } else if (this.bz == 'USD') {
        this.selectList.forEach(i => {
          num += i.quantity * i.part.purchasePriceUsd
        })
      }
      else {

        this.selectList.forEach(i => {
          num += i.quantity * i.part.purchasePriceEur
        })

      }
      }
      

      if (num == 0) {
        return 0
      } else {
        return num.toFixed(2)
      }
    }
  },
  mounted () {

  },
  methods: {
    plss(){
      console.log(this.xlist);
      
      this.$confirm(this.$t('menu.queddshanchuxuan'), '', {
          confirmButtonText: this.$t('menu.Confirm'),
          cancelButtonText: this.$t('menu.Cancel'),
          type: 'warning'
        }).then(() => {
            this.xlist.forEach(e=>{
              this.delaaa(e)
            })
       
       console.log(this.activeName);
       
         
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
    },
     delaaa (id) {
      let that = this
      let param = new URLSearchParams();
      let ID = id
      cartDel(param, ID).then(r => {
        if (r.data.code == 200) {
          // this.$message.success('删除成功')
          that.getCartList()
        } else {
          this.$message.error(r.data.msg)
        }
      })
    },
        async accc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
          this.infoaa()

    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      if(res){  
// console.log(11111111111111111123123,this.bz,res);
      }
 
      this.acclist.forEach(e => {
        if (e.id == res.user.dealers[0].accTypeIdLs&&res.user.platform=='2') {
              this.bz = e.currencyType
          this.moneyType = this.bz


          // console.log(11111111111111111123123,this.bz);
        }
          if (e.id == res.user.dealers[0].accTypeIdSh&&res.user.platform!=='2') {
           this.bz = e.currencyType
          
             this.moneyType = this.bz
            console.log(22222,this.bz);
            

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
      })
    },
    handleClick(e){
      console.log(123123,e.name);
      if(e.name=='2'||e.name=='4'){
          this.dclist(this.cbaac)
          console.log(1, this.cbaac);
          
      }else{

        let a = sessionStorage.getItem('accTypeIdLs')
        this.dclist(a)
      
      console.log(2, this.accTypeId);
      }
      this.carttype=e.name
      this.getCartList ()
     
    },
   async dclist(z){
         let param = new URLSearchParams();
      const { data: res } = await myAcc(param);
     
      this.accTypeId = z
      
      res.data.accs.forEach(e => {
        if (e.accTypeId == z) {
          this.accountBalance = e.accountBalance
            this.zkbi=e.discountRate
           
        }
      })
    },
    downMoBan () {
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      link.href = this.downUrl;
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download", `${this.$t('menu.PartsImportTemplate')}.xlsx`);
      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
      //执行a标签
    },
    httpRequest (item) {
      // console.log(item.file.name);
      // this.fileList[0].name = item.file.name
      var formData = new FormData()
      formData.append('file', item.file)
      importFile(formData).then(res => {
        // this.fileList[0].name = item.file.name
        // console.log('success', res);

        if (res.data.code == 200) {
          this.$message.success('导入成功')

          setTimeout(() => {
            location.reload()
          }, 1000)

        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((err) => {
        this.$message.error(res.data.msg)
      })
    },
    openDaoRuDialog () {
      this.daoruFlag = true
    },
    formatPrice (row) {
      // console.log(row)
      let sum = 0
      if(this.tup=='2'){
              sum = row.quantity * row.unitPrice
      }else{
        if (this.bz == 'CNY') {
        sum = row.quantity * row.part.purchasePriceCny
      } else
        if (this.bz == 'USD') {
          sum = row.quantity * row.part.purchasePriceUsd
        } else {
          sum = row.quantity * row.part.purchasePriceEur
        }
      }
      

      return sum.toFixed(2)
    },
    clickRow (row) {

      // const selectData = this.$refs.multipleTable.selection
      // if (selectData.length > 0) {
      //   selectData.forEach(item => {
      //     // 判断 如果当前的一行被勾选, 再次点击的时候就会取消选中
      //     if (item == row) {
      //       this.$refs.multipleTable.toggleRowSelection(row, false);
      //     } else {
      //       // 不然就让当前的一行勾选
      //       this.$refs.multipleTable.toggleRowSelection(row, true);
      //     }
      //   })
      // }
      //  else {
      //   this.$refs.multipleTable.toggleRowSelection(row, true);
      // }
    },
    ckbd () {
      if(this.tup=='2'){
        this.$router.push('/ordera')
      }else{
        this.$router.push('/order')
      }
      
    },
    qxdel () {
      this.cartLista.forEach(e => {
        this.dela(e.id)
      })
      that.getCartList()
    },
    dela (id) {
      let that = this
      let param = new URLSearchParams();
      let ID = id
      cartDel(param, ID).then(r => {
        if (r.data.code == 200) {
          this.$message.success('删除成功')
          that.getCartList()
        } else {
          this.$message.error(r.data.msg)
        }
      })
    },
    formatChe (id) {
      let str = ''
      this.cheList.forEach(i => {
        if (i.id == id && this.inle == 'zh') {
          str = i.seriesModel
        }
        if (i.id == id && this.inle !== 'zh') {
          str = i.seriesModelEn
        }
      })
      return str
    },
    getlistMcSeriesModels () {
      listMcSeriesModels().then(r => {
        this.cheList = r.data.data
      })
    },
    formatAccount () {
      let str = ''
      this.accountList.forEach(i => {
        if (i.id == this.accTypeId) {
          str = i.name
          // this.moneyType = i.currencyType
          this.moneyType = this.bz
          // console.log(1, this.moneyType);

        }
      })
      return str
    },
    fhstuse (e) {
      // console.log(111, e);


      let str = ''
      if (e == 'CNY') {
        str = '￥'
      }
      // else if (e = 'EUR') {
      //   str = '€'
      // } 
      else if (e == 'USD') {
        str = '$'
      } else if (e == 'EUR') {
        str = '€'
      }
      return str
    },
    getListAccType () {
      listAccType().then(r => {
        this.accountList = r.data.data

      })
    },
    checkDisabled () {
      if (this.radioa == 'account' && Number(this.priceTotal) > Number(this.accountBalance) || this.btnType) {
        return true
      } else {
        return false
      }
    },
    //下单
    async updata () {
     if(this.tup=='2'){
      console.log(1,this.gb);
      
  // this.ckg =  this.gb[0].dictValue  // 德国endamoto.com
      this.hyVal = 'KD'   // 德国
     }
    
      console.log(this.ckg,this.hyVal,this.xlist);
      
      if ( this.hyVal && this.xlist.length != 0) {
        
        this.buySum = this.priceTotal
        this.btnType = true
        let param = new URLSearchParams();
        let accTypeId = this.accTypeId
        let address =''
        let orderType = this.carttype
    
        let cardId = this.xlist
        let paymentMethod = this.radioa
        let priceTerms = 'FOB'
        let shippingMethod = this.hyVal
        let userRemarks = this.remark
        let shippingDate = this.shippingDate ? this.shippingDate + ' 00:00:00' : ''
        let planNum = this.planNum
        let a = this.xlist
        let b = ''
        let currencyType = '' //this.moneyType
        let odername = 'po'
        if(this.tup=='2'){
          odername='so'
        }
        a.forEach((e, i) => {
          let c = ''
          if (i == 0) {
            c = '&cardId=' + e
          } else { 
            c = '&cardId=' + e
          }
          b = b + c
        })
        if (paymentMethod == 'account') {
          accTypeId = this.accTypeId
        }
        // this.common.httpUrl='https://shaggy-pumas-draw.loca.lt/'
        let cca =this.common.httpUrl+'/cart/order?accTypeId=' + accTypeId + '&address=' + address + b + '&paymentMethod=' + paymentMethod + '&priceTerms=' + priceTerms + '&shippingMethod=' + shippingMethod + '&userRemarks=' + userRemarks + '&shippingDate=' + shippingDate + '&planNum=' + planNum + '&currencyType=' + currencyType +'&orderType='+orderType+"&orderName="+odername
        if(accTypeId==null){
          cca=this.common.httpUrl+'/cart/order?address=' + address + b + '&paymentMethod=' + paymentMethod + '&priceTerms=' + priceTerms + '&shippingMethod=' + shippingMethod + '&userRemarks=' + userRemarks + '&shippingDate=' + shippingDate + '&planNum=' + planNum + '&currencyType=' + currencyType +'&orderType='+orderType+"&orderName="+odername
        }
         if(this.radiodk==true){
         
          if(this.priceTotal/100*this.zkbi>this.accountBalance){
            cca=cca+'&useDiscountRate=true&discountAmount='+this.ccbaopl(this.accountBalance)
          }else{
             cca=cca+'&useDiscountRate=true&discountAmount='+this.ccbaopl(this.priceTotal/100*this.zkbi)
          }
        }
        // const { data: res } = await cartordera(param,);
        // this.$http.get('http://fdms-test.bendamotor.cn/bendaFDMSTestWeb/cart/order?accTypeId=' + accTypeId + '&address=' + address + b + '&paymentMethod=' + paymentMethod + '&priceTerms=' + priceTerms + '&shippingMethod=' + shippingMethod + '&userRemarks=' + userRemarks + '&shippingDate=' + shippingDate + '&planNum=' + planNum + '&currencyType=' + currencyType,
        //   {

            this.$http.post(cca,{},
              {
                headers: {
              'authorization': sessionStorage.getItem('token')
            }
          })
          .then(async response => {
            // 处理响应数据
            if (response.data.code == 200) {
              this.ckg = ''
              this.hyVal = ''
              this.shippingDate = ''
              this.planNum = ''
              this.remark = ''
              this.successType = true
              setTimeout(() => {
                this.btnType = false
              }, 1000);
              await this.myacc()
              await this.getCartList()

            } else {
              this.$message.error(response.data.msg);
              setTimeout(() => {
                this.btnType = false
              }, 1000);
            }
          })
          .catch(error => {
            // 处理错误情况
            setTimeout(() => {
              this.btnType = false
            }, 1000);
          });
        // const { data: res } = await cartorder(param, accTypeId, address, cardId, paymentMethod, priceTerms, shippingMethod, userRemarks,shippingDate,planNum);
      } else {
        this.$message.error('请填写完整信息或选择要结算的商品')
        return
      }


    },
    //账户
    async myacc () {
      let param = new URLSearchParams();
      const { data: res } = await myAcc(param);
      let a = sessionStorage.getItem('accTypeIdLs')
      this.accTypeId = a
      
      res.data.accs.forEach(e => {
        if (e.accTypeId == a) {
          this.accountBalance = e.accountBalance
            this.zkbi=e.discountRate
           
        }else{
          console.log(123123,e.accTypeId);
          
           this.cbaac=e.accTypeId
        }
      })
      // this.accTypeId = res.data.accs[0].accTypeId
      // this.accountBalance = res.data.accs[0].accountBalance
    },
    //账户 
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', this.uesrid);
      this.gb = res.data
      if(this.tup=='2'){
      console.log(1,this.gb);
      
  this.ckg =   res.data[0].dictValue  // 德国endamoto.com
      this.hyVal = 'KD'   // 德国
     }
      console.log(12,res);
      
    },
    bbca (e) {
      // console.log(1123,e)
      let a = ''
      let b = this.aeera
      b.forEach(z => {
        if (z.dictLabel == e) {
          a = z
        }
      })
      let bb = ''
      if (this.inle == 'zh') {
        bb = a.dictLabel
      } else {
        bb = a.dictLabelEn
      }
      return bb
    },
    async aeer () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 'area');
      this.aeera = res.data
    },
    async downloadUrl () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 't_excel_template');
      console.log(res)
      res.data.forEach(e => {
        if (e.dictLabel == "购物车导入模板") {
          this.downUrl = e.dictValue
        }
      })

    },
    getInfoa () {
      getInfo().then(r => {
        if (r.data.code == 200) {
          this.addressData = r.data.user.dealers
          this.radio = this.addressData[0].id
          this.raddata = this.addressData[0]
          this.uesrid = r.data.user.dealers[0].id
          this.gbquerytype()
        }
      })
    },
    jg () {

      let param = new URLSearchParams();

      querytype(param, 't_po_price_item').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data

        }
      })
      querytype(param, 't_po_shipment_method').then(r => {
        if (r.data.code == 200) {
          this.hyList = r.data.data

        }
      })
    },
    // 单选操作
    clickChange (row) {
      // 因为是单选，所以每次选择之前先进行清空操作
      this.addressPop = false
      this.radio = row
      this.raddata = this.addressData[this.radio]
    },
    changeNum (type, e, id) {
      let that = this
      let param = new URLSearchParams();
      const ID = id
      if (type == 'add') {
        e++
      } else {
        e--
      }
      cartQuantity(
        param,
        ID,
        e
      ).then(r => {
        if (r.data.code == 200) {
          this.cartList.forEach((z, i) => {
            if (z.id == ID) {
              this.cartList[i].quantity = e
            }
          })
          // that.getCartList()
        }
      })
    },
    handleSelectionChange (e) {
      this.selectList = e
      this.xlist = []
      e.forEach(e => {
        this.xlist.push(e.id)
      })
    },
      sxss(e){
      let a =[]
     if(e.length>0){
       e.forEach(z=>{
        if(z.orderType==this.activeName){
          a.push(z)
        }
      })
     }
      return a
    },
      ccbaopl(e){
    let a = 0
   if(e!==null &&e!==undefined){
      if(e>0){
        let c = Number(e)
      a=c.toFixed(2)
    }
    }
 
    
    return a
   },
    accTypeIdtt(e){
      let a = ''
      this.accountList.forEach(z=>{
        if(e==z.id){
          if(this.inle=='zh'){
            a=z.name
          }else{
            a=z.nameEn
          }
        }
      })
      return a
    },
    getCartList () {
      let that = this
      cartList().then(r => {
        if (r.data.code == 200) {
          let newArr = []
          let newArra = []
          let a1=0
          let a2=0
          let a3=0
          let a4=0
          for (let k in r.data.data) {
              newArr.push(r.data.data[k])
        // if(this.carttype=='1'){
        //       if(r.data.data[k][0].partCategory.useType!=='3'){
        //         if(r.data.data[k][0].orderType==this.activeName){
        //            let arr = r.data.data[k]
             
              
        //     newArr.push(arr)
            
        //         }
             
        //      }
        //     }else if(this.carttype=='2'){
        //       if(r.data.data[k][0].partCategory.useType=='3'){
        //        if(r.data.data[k][0].orderType==this.activeName){
        //            let arr = r.data.data[k]
             
              
        //     newArr.push(arr)
           
        //         }
        //      }
        //     }else if(this.carttype=='3'){
        //       if(r.data.data[k][0].partCategory.useType!=='3'){
        //        if(r.data.data[k][0].orderType==this.activeName){
        //            let arr = r.data.data[k]
             
              
        //     newArr.push(arr)
            
        //         }
        //      }
        //     }else if(this.carttype=='4'){
        //       if(r.data.data[k][0].partCategory.useType=='3'){
        //        if(r.data.data[k][0].orderType==this.activeName){
        //            let arr = r.data.data[k]
             
              
        //     newArr.push(arr)
          
        //         }
        //      }
           
        //     }
             if(r.data.data[k][0].partCategory.useType!=='3'){
                if(r.data.data[k][0].orderType==1){
                  
                    a1++
             
                
                }
                if(r.data.data[k][0].orderType==3){
                  
                    
                    a3++
                 
            
                }
             
             }
              if(r.data.data[k][0].partCategory.useType=='3'){
               if(r.data.data[k][0].orderType==2){
                  
                    a2++
             
                 
                }
                 if(r.data.data[k][0].orderType==4){
                  
                
                    a4++
                  
                }
             }
          
          }
          console.log(123,a1,a2,a3,a4)
          newArr = newArr.flat()
          
          
          let aac = newArr
          let bbc = []
          aac.forEach(i => {
            i.buyNum = i.part.minPurchaseQuantity
            if (i.deleted == false) {
              bbc.push(i)
            } else {
              newArra.push(i)
            }
          })
          that.cartList = that.sxss(bbc)
          that.cartLista = newArra
        }
        //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
        that.cartList.forEach((item) => {
          that.$nextTick(() => {
            that.$refs.multipleTable.toggleRowSelection(item, true);
          })
        })
      })
    },
    xzclick (e) {
      const selectData = this.$refs.multipleTable.selection
      if (selectData.length > 0) {
        selectData.forEach(item => {
          // 判断 如果当前的一行被勾选, 再次点击的时候就会取消选中
          if (item == e) {
            this.$refs.multipleTable.toggleRowSelection(e, false);
          } else {
            // 不然就让当前的一行勾选
            this.$refs.multipleTable.toggleRowSelection(e, true);
          }
        })
      }

    },
    del (id) {
      let that = this
      let param = new URLSearchParams();
      let ID = id
      cartDel(param, ID).then(r => {
        if (r.data.code == 200) {
          this.$message.success('删除成功')
          that.getCartList()
        } else {
          this.$message.error(r.data.msg)
        }
      })
    },
    openPop () {
      this.addressPop = true
    },
    confirmAddress () {

      this.addressPop = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-checkbox__label{
  font-size: 16px !important;color: #000;
}
.cart {
  display: flex;

  .table-box {
    padding: 20px 10px;
    padding-top: 0;
    flex: 8;
    margin-right: 10px;

    .top {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;

      .title {
        color: #e23d52;
      }

      .daoru {
        color: #409eff;
        text-decoration: underline;
      }

      .qingkong {
        color: #999999;
        cursor: pointer;
      }
    }
  }

  .daoru {
    color: #409eff;
    text-decoration: underline;
    margin-top: 10px;
    cursor: pointer;

  }

  /deep/.el-table th.is-center {
    text-align: left !important;
  }

  /deep/.el-table td.is-center {
    text-align: left !important;
  }

  .info-box {
    border: 1px solid #eee;
    padding: 30px;
    flex: 3;
    height: fit-content;

    .top1 {
      border-bottom: 1px solid #eee;
      padding: 10px 10px;
      padding-left: 0px;
      margin-top: -20px;
      height: 40px;
      font-size: 17px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        height: 40px;
        display: flex;
        align-items: center;
      }

      .pri {
        // margin-left: 18px;
        color: #d90064;

        p {
          margin-left: 10px;
        }
      }
    }

    .item {
      align-items: center;
      padding: 10px 10px;
      padding-left: 0;
      display: flex;

      .title {

        margin-right: 40px;
      }
    }

    .submit-btn {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #409eff;
      color: #fff;
      margin: 50px auto 0;
    }

    .pay-type {
      /deep/ .el-radio__label {
        font-size: 16px;
        color: #000000;
      }

      .blance {
        margin-top: 20px;
      }
    }

    .address {
      position: relative;
      padding: 10px 15px;
      width: 200px;

      .gh {
        cursor: pointer;
        color: #409eff;
        position: absolute;
        right: 0;
        top: 0;
        text-decoration: underline;
      }
    }
  }
}

.confirm {
  margin: 0 auto;
  width: 240px;
  height: 50px;
  margin-top: 20px;
  color: #fff;
  background-color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.del {
  color: #e23d52;
  cursor: pointer;
}

.hui {
  background-color: #d7d7d7 !important;
  border: none !important;
}

.el-icon-minus {
  flex: 2;
  display: flex;
  justify-content: center;
}

.input-number {
  flex: 7;
  display: flex;
  justify-content: center;
}

.el-icon-plus {
  flex: 2;
  display: flex;
  justify-content: center;
}

/deep/.el-textarea__inner {
  font-family: 'element-icons' !important;
}

.daoru-box {
  display: flex;
  font-size: 16px;

  .daoru-download {
    cursor: pointer;
    color: #409eff;
    margin-left: 10px;
  }
}

.daoru-btn {
  cursor: pointer;
  width: 180px;
  height: 35px;
  font-size: 16px;
  border: 1px solid #797979;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
}

.daoru-confirm {
  width: 300px;
  margin: 60px auto 0;
  background-color: #aaaaaa;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.cconfirm {
  background-color: #409eff !important;
}

.mgauto {
  display: flex;
  align-items: center;
  justify-content: center;
}

// .daoru-big {
//   height: 400px;
// }</style>
